import { ProductKey } from 'generated/types'

const PRODUCTS = ['core', 'later', 'spend', 'early']

export const BLUE_THEME = '#164A8A'

export const product = (route: string, currentProduct?: string) => {
  const product =
    PRODUCTS.find((product) => route.includes(product)) ||
    currentProduct?.toLowerCase()

  switch (product) {
    case 'core':
    case 'invest':
      return ProductKey.Invest
    case 'later':
      return ProductKey.Later
    case 'spend':
      return ProductKey.Spend
    case 'early':
      return ProductKey.Early
    default:
      return ProductKey.Invest
  }
}
